<template>
  <div class="login-block auth-shell">
    <div class="col-10 col-sm-8 col-xl-3">
      <el-card class="auth-card">
        <div class="card-title auth-title fs-4 pb-3">
          РЕГИСТРАЦИЯ
        </div>
        <el-form
          size="large"
          ref="form"
          :model="form"
          :rules="rules"
          class="text-start auth-form"
          status-icon>
          <el-form-item prop="name" :rules="rules.name">
            <el-input placeholder="Ваше имя" v-model="form.name" type="text" autocomplete="off" />
          </el-form-item>

          <el-form-item prop="email" :rules="rules.email">
            <el-input placeholder="E-mail" v-model="form.email" type="text" autocomplete="off" />
          </el-form-item>

          <el-form-item prop="password" :rules="rules.password">
            <el-input placeholder="Пароль" v-model="form.password" type="password" autocomplete="off" show-password />
          </el-form-item>

          <el-form-item prop="confirmPassword" :rules="rules.confirmPassword">
            <el-input placeholder="Повторите пароль" v-model="form.confirmPassword" type="password" autocomplete="off" show-password />
          </el-form-item>

          <el-form-item
            prop="acceptTerms"
            :rules="[{ required: true, message: 'Вы должны принять условия', trigger: 'change' }]"
          >
            <el-checkbox-group v-model="form.acceptTerms">
              <el-checkbox label="accepted">Я принимаю условия</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <div class="terms-links auth-terms-links">
              <el-link type="primary" underline href="https://lineon.me/wp-content/uploads/politika_obrabotki_personalnyh_dannyh.pdf" target="_blank">Политика обработки ПД</el-link>,
              <el-link type="primary" underline href="https://lineon.me/wp-content/uploads/politika_transgranichnoj_peredachi_personalnyh_dannyh.pdf" target="_blank">Трансграничная передача ПД</el-link>,
              <el-link type="primary" underline href="https://lineon.me/wp-content/uploads/politika-oplaty-i-vozvrata.pdf" target="_blank">Оплата и возврат</el-link>,
              <el-link type="primary" underline href="https://lineon.me/wp-content/uploads/soglasie_na_obrabotku_personalnyh_dannyh.pdf" target="_blank">Согласие на обработку ПД</el-link>,
              <el-link type="primary" underline href="https://lineon.me/wp-content/uploads/soglasie_na_poluchenie_informaczionnyh_i_marketingovyh_rassylok.pdf" target="_blank">Маркетинговые рассылки</el-link>,
              <el-link type="primary" underline href="https://lineon.me/wp-content/uploads/polzovatelskoe-soglashenie.pdf" target="_blank">Пользовательское соглашение</el-link>,
              <el-link type="primary" underline href="https://lineon.me/wp-content/uploads/prava_subekta_personalnyh_dannyh.pdf" target="_blank">Права субъекта ПД</el-link>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="w-100 text-end">
              <el-button class="auth-submit" :loading="loading" @click="register">Зарегистрироваться</el-button>
            </div>
          </el-form-item>

          <div class="alt-link auth-alt-link text-center mt-3">
            Уже есть аккаунт? <router-link to="/">Войти</router-link><br />
            <router-link to="/forgot-password">Забыли пароль?</router-link>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RegisterBlock',
  data() {
    return {
      loading: false,
      form: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        acceptTerms: []
      },
      rules: {
        email: [
          { required: true, message: 'Введите адрес электронной почты' },
          { type: 'email', message: 'Введите корректный адрес' },
          { validator: (_rule, value, callback) => this.validateEmail(value, callback), trigger: 'blur' }
        ],
        name: [{ required: true, message: 'Введите имя' }],
        password: [{ required: true, message: 'Введите пароль' }],
        confirmPassword: [
          { required: true, message: 'Повторите пароль' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('Пароли не совпадают'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions('auth', ['checkEmail', 'registerAccount']),
    async validateEmail(value, callback) {
      if (!value) return callback()
      const exists = await this.checkEmail(value)
      if (exists) {
        callback(new Error('Эта почта уже занята'))
      } else {
        callback()
      }
    },
    async register() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return

        this.loading = true
        try {
          const res = await this.registerAccount(this.form)
          if (res?.success) {
            this.$router.push('/')
          }
        } catch (e) {
          console.error(e)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.alt-link {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
}
.terms-links {
  display: block;
  width: 100%;
  margin-top: 6px;
  line-height: 1.4;
}
.terms-links a {
  display: inline-block;
  margin-left: 4px;
  margin-right: 4px;
  font-size: 12px;
}
</style>
